import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { Message } from 'src/app/core/class/message';
import { CommonService } from 'src/app/core/services/common.service';
import { EnterpriseService } from 'src/app/core/services/enterprise.service';
import {BaseComponent} from 'src/app/shared/components/base/base.component';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { AddConfigIpComponent } from '../add-config-ip/add-config-ip.component';
import { Router } from '@angular/router';
import { AddConfigIpWithFileComponent } from '../add-config-ip-with-file/add-config-ip-with-file.component';

@Component({
  selector: 'app-enterprise-config-enterprise',
  templateUrl: './enterprise-config-enterprise.component.html',
  styleUrls: ['./enterprise-config-enterprise.component.scss']
})
export class EnterpriseConfigEnterpriseComponent extends BaseComponent implements OnInit, OnChanges,AfterViewInit {

  @Input() enterpriseConfigHsmAndBranch = {
    enableManageBranch: false,
    enableHsm: false,
    ipAlloweds: [],
    isIpAllowed: false,
    isTwoFactorAuthen: false,
    isTwoFactorAuthenExternal: false,
    isTwoFactorAuthenInternal: false,
    isEnterpriseActionLog: false,
    isShortName : false,
    shortName: '',
    shortNameEnterprise : {
      isShortName : false,
      shortName: ''
    }
  };


  @Output() getDataIp = new EventEmitter<boolean>();
  checkAll: boolean;
  dataSelected: Map<any, Document> = new Map<any, Document>();
  columnDefinitions: string[] = [ 'check','STT', 'ip', 'description', 'action' ];
  isFormChanging: boolean = false;
  isAddFileChanging: boolean = false;
  enterpriseId: string = '';
  paginate: Paginate;
  page = 0;
  pageSize = 10;
  listData = [];
  shortNameSave : string = "";
  constructor(private enterpriseService: EnterpriseService ,
    public commonService: CommonService,
    private dialog: MatDialog,
    private toastr: ToastrService,
    private router: Router,
    public message: Message ) {
    super(commonService, message);
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.enterpriseConfigHsmAndBranch) {
       this.changePaging();
    }
  }
  ngOnInit() {
    this.enterpriseId = localStorage.getItem('enterpriseId');
  }
  ngAfterViewInit(): void {
  
  }
  counter(index: number , from: number){
    return new Array(index).fill(0).map((x, i: number) => i + from);
  }

  onNoClick() {
    if (this.isFormChanging) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: this.message.getMessage('config_enterprise.data_config_change'),
        panelClass: 'scontract-overlay-dialog',
        disableClose: true
      });
      dialogRe.afterClosed().subscribe((rs) => {
        if (rs) {
          this.router.navigate(['/home-enterprise/analysis-report']);
        }
        dialogRe.close();
      });
      } else {
        this.router.navigate(['/home-enterprise/analysis-report']);
      }   
  }
  clickSend(data) {
    if (data) {
      if (!this.enterpriseConfigHsmAndBranch.isTwoFactorAuthen &&
        !this.enterpriseConfigHsmAndBranch.isTwoFactorAuthenExternal &&
        !this.enterpriseConfigHsmAndBranch.isTwoFactorAuthenInternal
      ) {
        this.enterpriseConfigHsmAndBranch.isTwoFactorAuthenExternal = true;
      }
    }
    this.enterpriseConfigHsmAndBranch.isTwoFactorAuthen = data;
    this.enterpriseConfigHsmAndBranch.isEnterpriseActionLog = data;
    this.isFormChanging = true;
  }
  clickEnterpriseActionLog(data){
     this.enterpriseConfigHsmAndBranch.isEnterpriseActionLog = data;
    this.isFormChanging = true;
  }
  clickConfigIp(data) {
    this.enterpriseConfigHsmAndBranch.isIpAllowed = data;
    this.isFormChanging = true;
  }
  checkAllCheckBox() {
    this.listData.forEach(data => {
      data.checked = this.checkAll;
      if (data.checked) {
        this.dataSelected.set(data.id, data);
      } else {
        this.checkAll = false;
        this.dataSelected.delete(data.id);
      }
    })
  }

  public onSelect(element) {
    if (this.listData == null
      || this.listData.length === 0) {
      return;
    }
    if (element.checked) {
      this.dataSelected.set(element.id, element);
    } else {
      this.dataSelected.delete(element.id);
    }

    this.checkCheckAll();
  }

  checkCheckAll() {
    if (this.dataSelected.size === 0) {
      this.checkAll = false;
      return;
    }
    // if (this.dataSelected.size === this.listData.length) {
    //   this.checkAll = true;
    //   return;
    // }
    this.checkAll = this.listData.every(doc => this.dataSelected.has(doc.id));
  }
  
  onClickDeleteElement(element: any): void {
    const dialogRe = this.dialog.open(WarningComponent, {
      width: '350px',
      data: this.commonService.format(this.message.getMessage('messages.confirm_delete_ip'), element.ip),
      panelClass: 'scontract-overlay-dialog',
      disableClose: true
    });
    dialogRe.afterClosed().subscribe((rs) => {
      if (rs) {
        this.isFormChanging = true;
        this.isAddFileChanging = true;
        this.enterpriseConfigHsmAndBranch.ipAlloweds = this.enterpriseConfigHsmAndBranch.ipAlloweds.filter(d => d.id !== element.id);
        this.dataSelected.delete(element.id);
        this.toastr.success(this.message.getMessage("config_enterprise.delete_config_enterprises"));
        this.changePaging();
        this.checkCheckAll();
      }
      dialogRe.close();
    });
  }
  onConfigIp() {
    const dialogRef = this.dialog.open(AddConfigIpComponent, {
      width: '70%',
      disableClose: true,
      maxWidth: '80vw',
      panelClass: 'scontract-overlay-dialog',
      autoFocus: false,
      data: {
        mode: 'ADD',
        ipAlloweds: this.enterpriseConfigHsmAndBranch.ipAlloweds
      },
    });
    dialogRef.afterClosed().subscribe((rs) => {
      if (rs) {
        this.enterpriseConfigHsmAndBranch.ipAlloweds = [
          rs,
          ...this.enterpriseConfigHsmAndBranch.ipAlloweds
        ];
        this.changePaging();
        this.isFormChanging = true;
        this.isAddFileChanging = true;
      }
    });
  }
  onUpdate(element: any) {
    const dialogRef = this.dialog.open(AddConfigIpComponent, {
      width: '70%',
      disableClose: true,
      maxWidth: '80vw',
      panelClass: 'scontract-overlay-dialog',
      autoFocus: false,
      data: {
        mode: 'EDIT',
        ipAlloweds: this.enterpriseConfigHsmAndBranch.ipAlloweds,
        ipSelected: element
      },
    });
    dialogRef.afterClosed().subscribe((rs) => {
      if (rs) {
        const indexUpdate = this.enterpriseConfigHsmAndBranch.ipAlloweds.findIndex(config => config.id === rs.id);
        if (indexUpdate > -1) {
          this.enterpriseConfigHsmAndBranch.ipAlloweds[indexUpdate] = rs;
        }
        this.changePaging();
        this.isFormChanging = true;
        this.isAddFileChanging = true;
      }
    });
  }
  onSave() {
    this.enterpriseConfigHsmAndBranch.shortNameEnterprise = {
      isShortName: this.enterpriseConfigHsmAndBranch.isShortName,
      shortName: this.enterpriseConfigHsmAndBranch.shortName
    };
    const data = {
      isTwoFactorAuthen: this.enterpriseConfigHsmAndBranch.isTwoFactorAuthen,
      isTwoFactorAuthenInternal: this.enterpriseConfigHsmAndBranch.isTwoFactorAuthenInternal,
      isTwoFactorAuthenExternal: this.enterpriseConfigHsmAndBranch.isTwoFactorAuthenExternal,
      isIpAllowed: this.enterpriseConfigHsmAndBranch.isIpAllowed,
      ipAlloweds: this.enterpriseConfigHsmAndBranch.ipAlloweds,
      isEnterpriseActionLog : this.enterpriseConfigHsmAndBranch.isEnterpriseActionLog,
      enterpriseId: this.enterpriseId,
      isShortName: this.enterpriseConfigHsmAndBranch.isShortName,
      shortNameEnterprise: this.enterpriseConfigHsmAndBranch.shortNameEnterprise
    }
    this.enterpriseService.addEnterpriseConfig(data).subscribe(res => {
      if (res && res.success) {
        this.isFormChanging = false;
        this.isAddFileChanging = false;
        this.toastr.success(this.message.getMessage("config_enterprise.add_config_enterprises"));
        localStorage.setItem('shortNameSave', this.enterpriseConfigHsmAndBranch.shortName);
      } else {
        this.toastr.error(res.message);
      }
    })
  }
  onCheckboxInternalChange() {
    this.isFormChanging = true;
    this.enterpriseConfigHsmAndBranch.isTwoFactorAuthenInternal = !this.enterpriseConfigHsmAndBranch.isTwoFactorAuthenInternal;
  }
  onCheckboxExternalChange() {
    this.isFormChanging = true;
    this.enterpriseConfigHsmAndBranch.isTwoFactorAuthenExternal = !this.enterpriseConfigHsmAndBranch.isTwoFactorAuthenExternal;
  }
  onFilterData(page: number = 0, pageSize: number = 10) {
    this.page = page;
    this.pageSize = pageSize;
    
    this.listData = [];
    const a: number = page * pageSize;
    this.enterpriseConfigHsmAndBranch.ipAlloweds.forEach((ele, i) => {
      if (a <= i && i < a + pageSize) {
        this.listData.push(ele);
      }
      ele.order = i + 1;
    });
    this.paginate = {
      currentPage: page,
      pageSize: pageSize,
      totalRow: this.enterpriseConfigHsmAndBranch.ipAlloweds.length,
      totalPage: Math.ceil(this.enterpriseConfigHsmAndBranch.ipAlloweds.length / pageSize),
      totalPageArray: this.counter(Math.ceil(this.enterpriseConfigHsmAndBranch.ipAlloweds.length / pageSize),1),
      no: this.counter(pageSize, page * pageSize +1)
    };
    this.checkCheckAll();
  }

  changePaging() {
    this.listData = [];
    this.enterpriseConfigHsmAndBranch.ipAlloweds.forEach((e, index) => {
      if (index < 10 ) {
        this.listData.push(e);
      }
      e.order = index + 1;
    })
    this.paginate = {
      currentPage: this.page,
      pageSize: this.pageSize,
      totalRow: this.enterpriseConfigHsmAndBranch.ipAlloweds.length,
      totalPage: Math.ceil(this.enterpriseConfigHsmAndBranch.ipAlloweds.length / this.pageSize),
      totalPageArray: this.counter(Math.ceil(this.enterpriseConfigHsmAndBranch.ipAlloweds.length / this.pageSize),1),
      no: this.counter(this.pageSize, this.page * this.pageSize + 1)
    };
  }

  closeMenu() {

  }
  openMenuDelete(){
    const dialogRe = this.dialog.open(WarningComponent, {
      width: '350px',
      data: this.commonService.format(this.message.getMessage('messages.confirm_delete_mul_ip'), this.dataSelected.size),
      panelClass: 'scontract-overlay-dialog',
      disableClose: true
    });
    dialogRe.afterClosed().subscribe((rs) => {
      if (rs) {
        this.isFormChanging = true;
        this.isAddFileChanging = true;
        this.enterpriseConfigHsmAndBranch.ipAlloweds = this.removeSelectedIPs(this.enterpriseConfigHsmAndBranch.ipAlloweds, this.dataSelected);;
        this.dataSelected.clear();
        this.toastr.success(this.message.getMessage("config_enterprise.delete_config_enterprises"));
        this.changePaging();
        this.checkCheckAll();
      }
      dialogRe.close();
    });
  }
  removeSelectedIPs(ipList: any, ipSelected: any) {
    return ipList.filter(ip => !ipSelected.has(ip.id));
  }
  checkDisableSave() {
    let checkDisable: boolean = false;
    if (
      this.isFormChanging && (
        (this.enterpriseConfigHsmAndBranch.isTwoFactorAuthen
          && (this.enterpriseConfigHsmAndBranch.isTwoFactorAuthenExternal || this.enterpriseConfigHsmAndBranch.isTwoFactorAuthenInternal)
          && this.enterpriseConfigHsmAndBranch.isIpAllowed && this.enterpriseConfigHsmAndBranch.ipAlloweds.length > 0)
        || (!this.enterpriseConfigHsmAndBranch.isTwoFactorAuthen && this.enterpriseConfigHsmAndBranch.isIpAllowed && this.enterpriseConfigHsmAndBranch.ipAlloweds.length > 0)
        || (this.enterpriseConfigHsmAndBranch.isTwoFactorAuthen
          && (this.enterpriseConfigHsmAndBranch.isTwoFactorAuthenExternal || this.enterpriseConfigHsmAndBranch.isTwoFactorAuthenInternal)
          && !this.enterpriseConfigHsmAndBranch.isIpAllowed)
        || (!this.enterpriseConfigHsmAndBranch.isIpAllowed && !this.enterpriseConfigHsmAndBranch.isTwoFactorAuthen)
      )
      && !(
        this.enterpriseConfigHsmAndBranch.isShortName &&
        (!this.enterpriseConfigHsmAndBranch.shortName ||
         !this.enterpriseConfigHsmAndBranch.shortName.trim())
      )
    ) {
      checkDisable = true;
    }
  
    return checkDisable;
  }
  onAddLot() {
    if (this.isFormChanging) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: this.message.getMessage('config_enterprise.data_config_change'),
        panelClass: 'scontract-overlay-dialog',
        disableClose: true
      });
      dialogRe.afterClosed().subscribe((rs) => {
        dialogRe.close();
        if (rs) {
          const dialogRef = this.dialog.open(AddConfigIpWithFileComponent, {
            width: '70%',
            disableClose: true,
            maxWidth: '80vw',
            panelClass: 'scontract-overlay-dialog',
            autoFocus: false,
          });
          dialogRef.afterClosed().subscribe((rs) => {
            if (rs) {
              this.getDataIp.emit(true);
              this.page = 0;
              this.pageSize = 10;
              this.changePaging();
              this.dataSelected.clear();
              this.checkCheckAll();
            }
          });
        }
      });
    } else {
      const dialogRef = this.dialog.open(AddConfigIpWithFileComponent, {
        width: '70%',
        disableClose: true,
        maxWidth: '80vw',
        panelClass: 'scontract-overlay-dialog',
        autoFocus: false,
      });
      dialogRef.afterClosed().subscribe((rs) => {
        if (rs) {
          this.getDataIp.emit(true);
          this.page = 0;
          this.pageSize = 10;
          this.changePaging();
          this.dataSelected.clear();
          this.checkCheckAll();
        }
      });
    }  
  }

  clickUseShortName(value: boolean): void {
    this.enterpriseConfigHsmAndBranch.isShortName = value;
    //this.enterpriseConfigHsmAndBranch.shortNameEnterprise.isShortName = value;
  
    if (!value) {
      // Tắt toggle xóa giá trị đã nhập
      // this.enterpriseConfigHsmAndBranch.shortName = '';
    }else{
      this.enterpriseConfigHsmAndBranch.shortName = localStorage.getItem('shortNameSave');
    }
    this.isFormChanging = true;
  }

  trimValue(): void {
  if (this.enterpriseConfigHsmAndBranch.shortName) {
    this.enterpriseConfigHsmAndBranch.shortName = this.enterpriseConfigHsmAndBranch.shortName.trim();
  }
}
}

class Paginate {
  currentPage: number;
  pageSize: number;
  totalRow: number;
  totalPage: number;
  totalPageArray: any;
  no: any;
}

